import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a84b404bedae70014d5d54f_1787143138862_354bd1f4/creatorindex360/src/app/isx-observatory/page.tsx");
